import React from "react";

export interface IconBindProps {
  hasTitle?: boolean;
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

export const IconBind: React.FC<IconBindProps> = ({ hasTitle, width = 12, height = 12, fill = "#fff", className }) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      className={className}
      fillRule="evenodd"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.72 11.72"
    >
      {hasTitle && <title>IconBind</title>}
      <path d="M11.31,4.36,9.22,6.45a1.39,1.39,0,0,1-2,0l-.59-.59L8.43,4.09a.57.57,0,0,0,0-.79.56.56,0,0,0-.79,0L5.86,5.07l-.59-.59a1.4,1.4,0,0,1,0-2L7.37.41a1.38,1.38,0,0,1,2,0l2,2a1.39,1.39,0,0,1,0,2M6.45,9.22,4.36,11.31a1.39,1.39,0,0,1-2,0l-2-2a1.38,1.38,0,0,1,0-2l2.1-2.1a1.4,1.4,0,0,1,2,0l.59.59L3.3,7.64a.56.56,0,0,0,0,.79.59.59,0,0,0,.39.16.61.61,0,0,0,.4-.16L5.86,6.65l.59.59a1.39,1.39,0,0,1,0,2" />
    </svg>
  );
};
